import { CellContent, Table, TableRow } from './types';
import { isInstanceOfCellContentObject } from './util';

export class TableSearcher {
  public table?: Table;

  public get allHiddenBySearch(): boolean {
    return this._allHiddenBySearch;
  }

  private latestSearchTerm: string | undefined;
  private _allHiddenBySearch: boolean = false;

  public search(searchTerm: string): void {
    this.latestSearchTerm = searchTerm;
    if (!this.table) {
      return;
    }

    this.searchNonHiddenColumns(searchTerm, this.table);
  }

  public restoreSearch(): void {
    if (!this.table || !this.latestSearchTerm) {
      return;
    }
    this.searchNonHiddenColumns(this.latestSearchTerm, this.table);
  }

  public searchNonHiddenColumns(searchTerm: string, table: Table) {
    if (searchTerm.length < 1) {
      this._allHiddenBySearch = false;
      for (const row of table.rows) {
        row.hiddenBySearch = false;
      }
      return;
    }

    this._allHiddenBySearch = true;

    for (const row of table.rows) {
      row.hiddenBySearch = true;

      for (const cell of TableSearcher.allNonHiddenColumnsOfRow(row, table)) {
        let matchFound: boolean = false;

        if (isInstanceOfCellContentObject(cell)) {
          matchFound = cell.label.toLowerCase().includes(searchTerm.toLowerCase());
        }
        else if (typeof cell === 'string') {
          matchFound = cell.toLowerCase().includes(searchTerm.toLowerCase());
        }

        if (matchFound) {
          row.hiddenBySearch = false;
          this._allHiddenBySearch = false;
          break;
        }
      }
    }
  }

  private static * allNonHiddenColumnsOfRow(row: TableRow, table: Table): Iterable<CellContent> {
    for (const columnDefs of table.headers) {
      for (const columnDef of columnDefs) {
        const columnIndex: number = columnDef.column;
        const cell: CellContent = row.content[columnIndex];
        yield cell;
      }
    }
  }
}
